export function pushga(data: {
  event: string;
  eventName?: string;
  selectedEventOption?: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
  userEmail?: string;
  value?: number;
  experimentDetailsList?: Array<Object>;
}) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    if (!data.event && data.eventCategory) data.event = data.eventCategory;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  } catch (error) {
    console.error(error);
  }
}

export function pushEcommerceGAEvent(data: { event: string; ecommerce: any }) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  } catch (error) {
    console.error(error);
  }
}
